module.exports = __webpack_public_path__ + "static/img/Ellipse 100.7d5e37a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 100.png
// module id = NTNA
// module chunks = 1